import { render, staticRenderFns } from "./ProductDetailsV3New.vue?vue&type=template&id=e73826d8"
import script from "./ProductDetailsV3New.vue?vue&type=script&lang=js"
export * from "./ProductDetailsV3New.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsV3New.vue?vue&type=style&index=0&id=e73826d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports